import { FormInstance, message } from 'antd'

import { IdentityType } from '~/redux-modules/identity/type'
import getErrorMessage from '~/lib/getErrorMessage'
import logger from '~/lib/logger'

import { PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD } from './constants'

export const handleUpdatePassword = async ({
    form,
    setLoading,
    identity,
    onCancel,
    updatePassword,
}: {
    form: FormInstance
    setLoading: Function
    identity: IdentityType
    onCancel: () => void
    updatePassword: Function
}) => {
    if (!form.isFieldsTouched()) {
        return onCancel()
    }

    try {
        await form.validateFields([PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD])
    } catch (err) {
        return
    }

    setLoading(true)

    try {
        await updatePassword({
            variables: {
                id: identity.id,
                currentPassword: form.getFieldValue(PASSWORD),
                newPassword: form.getFieldValue(NEW_PASSWORD),
            },
        })

        message.success('Password updated')
        form.resetFields()
        onCancel()
    } catch (err) {
        message.error(getErrorMessage(err) || 'Failed to update password')
        logger.exception(err, {
            extra: {
                info: 'MyAccountPage::Failed to update user password',
                identityId: identity.id,
            },
        })
    }

    setLoading(false)
}
